var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

var Base = require('front/components/Base/Base');

require('./Custom404.less');

module.exports = Base.extend({

    el: '.Custom404',

    events: {
        'click .Custom404-button': 'onSearchClick',
        'keyup .Custom404-input': 'onInputKeyUp'
    },

    initialize: function (options) {
        console.log('Custom404');

        return Base.prototype.initialize.apply(this, arguments);
    },

    activate: function (options) {

    },

    onSearchClick: function () {
        window.location.href = '/search/?query=' + this.$('.Custom404-input').val();
    },

    onInputKeyUp: function (e) {
        // If Enter pressed
        if (e.keyCode == 13) {
            this.onSearchClick();
        }
    }

});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Custom404/Custom404.js
// module id = 187
// module chunks = 0